import { NavLink } from '@components/core';
import { Cell } from '@components/grid';
import { pageList } from '@helpers/pages';
import * as React from 'react';
import styled from 'styled-components';

const MenuLink = styled(NavLink)`
  display: block;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 24px;

  :hover {
    color: ${({ theme }) => theme.nav.mobileHover || theme.nav.hover};
  }
`;

const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const LinkList = ({ toggleOpen }) => {
  return (
    <Cell>
      <List>
        {pageList.map(({ id, to, text }) => {
          return (
            <li key={id}>
              <MenuLink to={to} onClick={toggleOpen}>
                {text}
              </MenuLink>
            </li>
          );
        })}
      </List>
    </Cell>
  );
};

export default LinkList;
